import _ from 'underscore';
import {NO_VALID_BUILDINGS, RESET} from 'common/constants';
import SelectorBaseView from 'common/views/selector-base-view';
import {BuildingEnum} from 'common/proxies/enum-proxy';
import {sort} from 'common/utils/array-util';
import SelectorGroups from 'common/templates/selector-groups.html';
import {t} from 'common/utils/translation-util';

export default SelectorBaseView.extend({
  buildings: [],
  template: _.template(SelectorGroups),

  addBuilding(building) {
    this.buildings.push(building);
  },

  initialize(options) {
    this.dispatcher = options.dispatcher;
    this.collection.on(RESET, this.render, this);
  },

  getGroups() {
    const facilities = this.collection.getFacilities();
    const groupPrefix = t('All ');
    const groups = [];
    const buildings = [];
    const customParents = {};
    const customGroupsFound = {};
    const bos = [];
    const bosTypesFound = {};

    facilities.forEach((facility) => {
      const validatedFacility = this.validateFacility(facility);

      // Only consider facilities that
      // Are valid for the underlying app
      if (validatedFacility) {
        // Add valid buildings
        this.addBuilding(validatedFacility);
        buildings.push({
          text: validatedFacility.displayName,
          value: validatedFacility.urlElement,
        });

        // Add bOS specific types
        if (validatedFacility.type) {
          if (!bosTypesFound.hasOwnProperty(validatedFacility.type.slug)) {
            bosTypesFound[validatedFacility.type.slug] = true;
            bos.push({
              text: groupPrefix + validatedFacility.type.pluralize,
              value: validatedFacility.type.slug,
            });
          }
        }

        // Add user defined custom groups
        if (validatedFacility.groups) {
          validatedFacility.groups.forEach((group) => {
            if (!customParents.hasOwnProperty(group.parent)) {
              customParents[group.parent] = {
                label: group.parent,
                options: [{text: groupPrefix + group.name, value: group.id}],
              };
              customGroupsFound[group.name] = true;
            } else if (!customGroupsFound.hasOwnProperty(group.name)) {
              customParents[group.parent].options.push({
                text: groupPrefix + group.name,
                value: group.id,
              });
              customGroupsFound[group.name] = true;
            }
          });
        }
      }
    });

    // Add each group and options sorted alphabetically
    groups.push({
      label: null,
      options: [
        {
          text: BuildingEnum.ALL_FACILITIES.pluralize,
          value: BuildingEnum.ALL_FACILITIES.slug,
        },
      ],
    });

    groups.push({
      label: t('TYPE'),
      options: sort.alphabetical(bos, 'text'),
    });
    for (const key in customParents) {
      if (customParents.hasOwnProperty(key)) {
        groups.push({
          label: key.toUpperCase(),
          options: sort.alphabetical(customParents[key].options, 'text'),
        });
      }
    }
    groups.push({
      label: t('BUILDINGS'),
      options: sort.alphabetical(buildings, 'text'),
    });

    return groups;
  },

  render() {
    const groups = this.getGroups();

    if (!this.buildings.length) {
      if (this.dispatcher) {
        this.dispatcher.trigger(NO_VALID_BUILDINGS);
      }
    }
    this.$el.html(this.template({optionGroups: groups}));
    this.select2();
  },

  validateFacility(facility) {
    // Override
    // Gives sub-modules a chance to
    // Do something to an option before
    // It heads off for templating.
    // An example usage would be excluding
    // A facility whose meters don't
    // Meet some condition or other.
    return facility;
  },
});
